import styled from 'styled-components'

export const StyledClockWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-left: 24px;

    span {
      display: inline-block;
      margin: 0 10px;
      border-radius: 16px;
      color: #5f4dbc;
      background: rgba(95, 77, 188, 0.1);
      width: 60px;
      height: 68px;
      font-size: 32px;
      font-weight: 500;
      line-height: 68px;
      text-align: center;
    }
    b {
      font-size: 12px;
      color: #5f4dbc;
    }
  }

  ${({ theme }) => theme.media.sm`
    div {
      span {
        margin: 0 6px;
        border-radius: 8px;
        width: 40px;
        height: 46px;
        font-size: 24px;
        line-height: 46px;
      }
    }
  `}
`

export const StyledIcon = styled.img`
  width: 36px;
  height: 36px;

  ${({ theme }) => theme.media.sm`
    width: 24px;
    height: 24px;
  `}
`
